import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderTypes: [],
  seats: "",
  selectedTable: {
    id: null,
    tableNum: null,
  },
};

const finalOrderSlice = createSlice({
  name: "finalOrder",
  initialState,
  reducers: {
    selectOrderTypes(state, action) {
      state.orderTypes = action.payload;
    },
    selectSeats(state, action) {
      // state.seats = action.payload;
    },
    selectTable(state, action) {
      state.selectedTable = action.payload;
    },
  },
});

export const { selectOrderTypes, selectSeats, selectTable } =
  finalOrderSlice.actions;

export default finalOrderSlice.reducer;
